import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'ramda';
import { formatLinks } from '../../utils/text';

const format = compose(
  text => formatLinks(text, { className: 'chat-list_message-link' }),
  text => text.replace(/(<\/?(?:a)[^>]*>)|<[^>]+>/i, ''),
  text => {
    const tagsToReplace = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
    };
    return text.replace(/[&<>]/g, tag => tagsToReplace[tag] || tag);
  },
);

const Text = ({ text }) => (
  <div
    className="chat-list_message-line"
    dangerouslySetInnerHTML={{ __html: format(text || '') }}
  />
);

const ChatText = ({ text }) => {
  const messages = (text || '').split('\n');
  return (
    <Fragment>
      {messages.map((t, index) => (
        <Text key={index} text={t} />
      ))}
    </Fragment>
  );
};

Text.propTypes = {
  text: PropTypes.string.isRequired,
};

ChatText.propTypes = {
  text: PropTypes.string.isRequired,
};

export default React.memo(ChatText);



// WEBPACK FOOTER //
// ./app/javascript/common/components/ChatMessage/ChatText.js